var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { useTheme } from 'styled-components';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import Typography from '../../Styles/Typography/Typography';
import Icon from '../../Styles/Icons/Icon';
const MenuItemSyle = styled.div `
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: ${props => props.theme.paddingsMargins.themeMenuPadding};
  padding-left: ${props => props.theme.paddingsMargins.themePaddingSingle};
  padding-right: ${props => props.theme.paddingsMargins.themePaddingSingle};
  margin: ${props => props.theme.paddingsMargins.themeMenuMargin};
  color: transparent;
  transition: background-color 200ms ease-in-out;
  border-radius: ${props => props.theme.borders.borderRadius};
  &:hover {
    color: ${(props) => props.theme.utils.getColor(props.color)};
    background-color: ${(props) => props.theme.utils.getColor(props.color) + '11'};
  }
`;
const MenuItem = (_a) => {
    var { color = 'main', iconColor, children, labelSize = 'article', icon, id, skeleton, isLoading, onClick = () => { } } = _a, props = __rest(_a, ["color", "iconColor", "children", "labelSize", "icon", "id", "skeleton", "isLoading", "onClick"]);
    const theme = useTheme();
    return (isLoading
        ? _jsx(Skeleton, Object.assign({ height: labelSize, margin: theme.paddingsMargins.themeMargin, padding: theme.paddingsMargins.themePadding }, skeleton))
        : _jsxs(MenuItemSyle, Object.assign({ id: id, color: color, onClick: onClick }, props, { children: [icon && (_jsx(Icon, { size: labelSize, icon: icon, color: iconColor || color })), _jsx(Typography, Object.assign({ color: color, size: labelSize }, { children: children }))] })));
};
export default MenuItem;
